import { isApiError } from '@/core/http';

/**
 * Por que a edição ou a exclusão não aconteceu, em português. A API responde
 * com código e uma mensagem técnica; aqui vira o que a pessoa precisa saber
 * para seguir.
 */
function problem(e: unknown, fallback: string): string {
  if (!isApiError(e)) return fallback;
  if (e.code === 'network_error') return 'Sem conexão com o servidor. Nada foi alterado.';
  if (e.status === 403) return 'Você não tem permissão para editar este curso.';
  if (e.status === 404) return 'Este item não existe mais. Recarregue a página.';
  if (e.code === 'module_not_empty') return 'Exclua as aulas do módulo antes de excluí-lo.';
  if (e.code === 'last_published_lesson')
    return 'Um curso publicado precisa de pelo menos uma aula. Adicione outra antes ou arquive o curso.';
  if (e.status === 422) return 'Valor não aceito. Confira e tente de novo.';
  return fallback;
}

export const editProblem = (e: unknown) => problem(e, 'Não foi possível salvar. Tente de novo.');
export const deleteProblem = (e: unknown) => problem(e, 'Não foi possível excluir. Tente de novo.');
